var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuritySafeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23.382C11.7598 23.382 11.5199 23.3514 11.2899 23.2797C6.09986 21.8167 2.33984 16.8548 2.33984 11.4734V6.98205C2.33984 5.8362 3.14985 4.59833 4.18985 4.15841L9.75986 1.82576C11.2099 1.22214 12.7998 1.22214 14.2398 1.82576L19.8098 4.15841C20.8498 4.59833 21.6599 5.8362 21.6599 6.98205V11.4734C21.6599 16.8445 17.8898 21.8065 12.7098 23.2797C12.4798 23.3514 12.2398 23.382 11.9998 23.382ZM11.9998 2.92046C11.4298 2.92046 10.8698 3.03302 10.3298 3.25809L4.75986 5.59068C4.27986 5.79529 3.83984 6.46029 3.83984 6.99229V11.4836C3.83984 16.1795 7.13985 20.5174 11.6898 21.8065C11.8898 21.8679 12.1098 21.8679 12.3098 21.8065C16.8598 20.5174 20.1599 16.1795 20.1599 11.4836V6.99229C20.1599 6.46029 19.7198 5.79529 19.2398 5.59068L13.6699 3.25809C13.1299 3.03302 12.5698 2.92046 11.9998 2.92046Z",
    fill: "#878b93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.2597C10.23 12.2597 9 11.0014 9 9.44628C9 7.8912 10.23 6.63281 11.75 6.63281C13.27 6.63281 14.5 7.8912 14.5 9.44628C14.5 11.0014 13.27 12.2597 11.75 12.2597ZM11.75 8.16743C11.06 8.16743 10.5 8.74035 10.5 9.44628C10.5 10.1522 11.06 10.7251 11.75 10.7251C12.44 10.7251 13 10.1522 13 9.44628C13 8.74035 12.44 8.16743 11.75 8.16743Z",
    fill: "#878b93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7328C11.59 16.7328 11.25 16.3849 11.25 15.9654V12.8962C11.25 12.4768 11.59 12.1289 12 12.1289C12.41 12.1289 12.75 12.4768 12.75 12.8962V15.9654C12.75 16.3849 12.41 16.7328 12 16.7328Z",
    fill: "#878b93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafeDisabled);
export default __webpack_public_path__ + "static/media/security-safeDisabled.3e410febc5398d0e6cdf02338a389cc2.svg";
export { ForwardRef as ReactComponent };